// Wire `fundDetails[]` (the /portfolio and /sponsor fact-sheet block) -> the shape
// FundDetailModal reads, keyed by ticker. Shared by both module adapters, so it lives
// here rather than in either module (modules never import each other).

// Which documents a fund publishes IN THIS PLAN ('fact' | 'pros'), which decides the
// overlay's tab strip. A fund naming nothing recognisable returns undefined rather than
// an empty list, which the overlay reads as "assume both".
const DOC_ID_BY_TYPE = { factSheet: 'fact', prospectus: 'pros', fact: 'fact', pros: 'pros' };
const DOC_ORDER = ['fact', 'pros'];

export const mapFundDocuments = (docs) => {
  if (!Array.isArray(docs)) return undefined;
  const ids = new Set(docs.map((d) => DOC_ID_BY_TYPE[typeof d === 'string' ? d : d?.type]).filter(Boolean));
  return ids.size ? DOC_ORDER.filter((id) => ids.has(id)) : undefined;
};

/** `fundDetails[]` -> `{ [ticker]: detail }`, or undefined when the list is absent/empty. */
export const mapFundDetails = (fundDetails) => {
  if (!Array.isArray(fundDetails) || !fundDetails.length) return undefined;
  return Object.fromEntries(
    fundDetails.map((d) => [
      d.ticker,
      {
        benchmark: d.benchmark,
        category: d.category,
        objective: d.objective,
        assets: d.netAssets,
        inception: d.inceptionDate,
        turnover: d.turnover,
        costPer1000: d.costPer1000,
        fee12b1: d.fee12b1,
        salesCharge: d.salesCharge,
        mix: d.mix,
        compare: d.compare,
        holdings: d.topHoldings,
        documents: mapFundDocuments(d.documents),
      },
    ]),
  );
};
